import { useCallback } from "react";
import axios from "axios";
import { REACT_APP_ACR_API_BASE_URL, REACT_APP_ACR_API_PROTOCOL } from "../utlities/core.constants";

const REQUEST_TIMEOUT_MS = 30000;

function mapFieldErrors(data) {
  const errors = {};
  const list = data?.validationErrors || data?.ValidationErrors;
  if (Array.isArray(list)) {
    list.forEach((item) => {
      const key = item?.identifier || item?.Identifier;
      const message = item?.errorMessage || item?.ErrorMessage;
      if (key && message && !errors[key]) {
        errors[key] = message;
      }
    });
  }

  const problemErrors = data?.errors;
  if (problemErrors && typeof problemErrors === "object" && !Array.isArray(problemErrors)) {
    Object.entries(problemErrors).forEach(([key, messages]) => {
      const message = Array.isArray(messages) ? messages[0] : messages;
      if (key && message && !errors[key]) {
        errors[key] = message;
      }
    });
  }

  return errors;
}

/**
 * Posts a Buyer ACR request. Axios resolves any status below 500, so callers must branch on
 * `response.status`: 2xx success, 400 field errors, anything else (including 422, 5xx, timeout)
 * is a send failure the modal can retry.
 */
export default function useRequestAcr() {
  const requestAcr = useCallback(async (request) => {
    try {
      const response = await axios.post(
        `${REACT_APP_ACR_API_PROTOCOL}://${REACT_APP_ACR_API_BASE_URL}/api/acrrequest`,
        request,
        { timeout: REQUEST_TIMEOUT_MS }
      );

      if (response.status >= 200 && response.status < 300) {
        return { ok: true };
      }
      if (response.status === 400) {
        return { ok: false, type: "validation", fieldErrors: mapFieldErrors(response.data) };
      }
      return { ok: false, type: "send" };
    } catch {
      return { ok: false, type: "send" };
    }
  }, []);

  return { requestAcr };
}
